import React from 'react';
import { CouponModel } from 'models';
import { Button, IconButton } from '@mui/material';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';

export default function Coupons({ id, title = 'تمایش جزییات' }) {
  return (
    <>
      <CouponModel
        isPopup
        isAssign={false}
        disabled={false}
        multiSelect={false}
        title={title}
        // onAssign={onAssign}
        assigning={false}
        initFilter={{ ids: id, for_admin: 1 }}
        preSelected={[]}
        action={
          <Button
            size="medium"
            color="info"
            variant="contained"
            startIcon={<AssignmentRoundedIcon fontSize="small" />}
          >
            {title}
          </Button>
        }
      />
    </>
  );
}
